import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter';
import './index.css';
import App from './App';
import { msalInstance } from './auth/msalInstance';

async function bootstrap() {
  // msal-browser v3+ requires initialize() before any other API call.
  // We deliberately do NOT call handleRedirectPromise() here: doing so
  // would consume the redirect response (and fire LOGIN_SUCCESS) before
  // React mounts, leaving no subscriber to receive the ID token.
  // LoginPage.useEffect calls handleRedirectPromise() itself after mount
  // and acts directly on its return value.
  await msalInstance.initialize();

  const rootEl = document.getElementById('root');
  if (!rootEl) throw new Error('Root element not found');
  const root = ReactDOM.createRoot(rootEl);
  root.render(<React.StrictMode><App /></React.StrictMode>);
}

bootstrap();
